module.exports = __webpack_public_path__ + "img/lipstick_and_perfume_0.ef6c9b60.png";